import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Portal from "@material-ui/core/Portal";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import ManageUsersTable from "../table/ManageUsersTable";
import CloseableDialog from "./CloseableDialog";
import LogoutIcon from "@material-ui/icons/ExitToApp";
import CloseIcon from "@material-ui/icons/Close";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as Utils from "../../Utils";
import * as SessionInfo from "../../SessionInfo";
import { useSessionInfo } from "../../SessionInfo";
var ManageUsersDialog = function ManageUsersDialog(_ref) {
  var open = _ref.open,
    handleClose = _ref.handleClose,
    allowConfiguringTeams = _ref.allowConfiguringTeams;
  var _useSessionInfo = useSessionInfo(),
    _useSessionInfo2 = _slicedToArray(_useSessionInfo, 1),
    sessionInfo = _useSessionInfo2[0];
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    alertMessage = _React$useState2[0],
    setAlertMessage = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    users = _React$useState4[0],
    setUsers = _React$useState4[1];
  var propsVersion = sessionInfo && sessionInfo.props && sessionInfo.props.propsVersion || "v1";
  var userLicensed = sessionInfo && sessionInfo.props && sessionInfo.props.licensed;

  // Additional intelligence to decide if this dialog should be visible or not
  var forceDialogOpen;
  if (propsVersion === "v2") {
    var showManageUsersDialog = sessionInfo && sessionInfo.props && sessionInfo.props.showManageUsersDialog;
    forceDialogOpen = sessionInfo && showManageUsersDialog;
  } else {
    forceDialogOpen = sessionInfo && !userLicensed;
  }
  var dialogOpen = open || forceDialogOpen;
  React.useEffect(function () {
    if (dialogOpen) {
      populateTable();
    } else {
      setAlertMessage(null);
    }
  }, [dialogOpen]);
  var onClose = function onClose() {
    if (userLicensed) {
      handleClose();
    } else {
      // Logout
      SessionInfo.clear();
    }
  };
  var saveUsers = function saveUsers() {
    var url = "cloudapi/configuration/licensedUsers";
    Utils.fetchData(url, {
      method: "post",
      body: JSON.stringify({
        list: users
      })
    }, true, false).then(function (response) {
      setAlertMessage({
        success: true,
        message: "Saved successfully."
      });

      // Refresh session to check whether user has become (un)licensed
      SessionInfo.refresh();
    }).catch(function (response) {
      Utils.getErrorMessage(response, "Failed to save users.").then(function (message) {
        return setAlertMessage({
          success: false,
          message: message
        });
      });
    });
  };
  var populateTable = function populateTable() {
    var url = "cloudapi/configuration/licensedUsers";
    Utils.fetchData(url).then(function (users) {
      setUsers(users);
    }).catch(function (response) {
      setUsers([]);
      Utils.getErrorMessage(response, "Failed to fetch users.").then(function (message) {
        return setAlertMessage({
          success: false,
          message: message
        });
      });
    });
  };
  if (!sessionInfo) {
    return null;
  }
  return /*#__PURE__*/React.createElement("span", null, alertMessage && /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(Snackbar, {
    open: alertMessage,
    autoHideDuration: 6000,
    onClose: function onClose() {
      return setAlertMessage(null);
    }
  }, /*#__PURE__*/React.createElement(Alert, {
    onClose: function onClose() {
      return setAlertMessage(null);
    },
    severity: alertMessage && alertMessage.success ? "success" : "error"
  }, alertMessage && (alertMessage.message || "Unknown error")))), /*#__PURE__*/React.createElement(CloseableDialog, {
    dividers: true,
    open: dialogOpen,
    title: "Manage Users",
    maxWidth: "md",
    handleClose: onClose,
    closeIcon: userLicensed ? /*#__PURE__*/React.createElement(CloseIcon, null) : /*#__PURE__*/React.createElement(LogoutIcon, null)
  }, /*#__PURE__*/React.createElement(DialogContent, {
    dividers: true
  }, users ? /*#__PURE__*/React.createElement(ManageUsersTable, {
    users: users,
    setUsers: setUsers,
    allowConfiguringTeams: allowConfiguringTeams
  }) : /*#__PURE__*/React.createElement(CircularProgress, {
    color: "inherit",
    style: {
      marginLeft: "10px"
    },
    size: 20
  })), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: saveUsers
  }, "Save"))));
};
export default ManageUsersDialog;